"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSSR = exports.isMobile = exports.getSiteLanguage = void 0;
exports.getSiteLanguage = function (wixCodeApi, fallbackLanguage) {
    if (fallbackLanguage === void 0) { fallbackLanguage = 'en'; }
    if (wixCodeApi.window.multilingual.isEnabled) {
        return wixCodeApi.window.multilingual.currentLanguage;
    }
    // NOTE: language can be null (see WEED-18001)
    return wixCodeApi.site.language || fallbackLanguage;
};
exports.isMobile = function (wixCodeApi) {
    return wixCodeApi.window.formFactor === 'Mobile';
};
exports.isSSR = function (wixCodeApi) {
    return wixCodeApi.window.rendering.env === 'backend';
};
//# sourceMappingURL=helpers.js.map